import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class BrandService {

    constructor(private _http: HttpClient) { }

    getproducts(data) {
        return this._http.post(environment.api_url+'category/product',data);
    }

    getbrandproduct(data) {
        return this._http.post(environment.api_url+'category/brand/product',data);
    }

}
